export default __webpack_public_path__ + "static/media/misc-books1-768w.2b30e268.png";